import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import ConfirmDialog from "../components/ConfirmDialog";
import {
  Card,
  Spinner,
  Table,
  Button,
  Select,
  Modal,
  TextInput,
  Dropdown,
  Label,
  Badge,
} from "flowbite-react";
import { Store } from "../context/store";
import { useNavigate } from "react-router-dom";
import apiRequest from "../utils/apiRequest";
import {
  HiBadgeCheck,
  HiCalendar,
  HiCheck,
  HiCreditCard,
  HiKey,
  HiMail,
  HiOutlineAcademicCap,
  HiOutlineExclamationCircle,
  HiPhone,
  HiDotsVertical,
  HiEye,
  HiPlus,
  HiUsers,
  HiUser,
} from "react-icons/hi";
import { useAllPermissions } from "../utils/usePermission";
import DashboardLayout from "../components/layout/DashboardLayout";

function Users() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  const [loggedInUser] = store.loggedInUser;
  let [staff, setStaff] = useState([]);
  let [roles, setRoles] = useState([]);
  let [msg, setMsg] = useState("");
  let [error, setError] = useState("");
  let [errorColor, setErrorColor] = useState("");
  const [staffDetails, setStaffDetails] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    role: "",
  });
  let [singleStaff, setSingleStaff] = useState({});
  let [loading1, setLoading1] = useState(false);
  let [loading2, setLoading2] = useState(false);
  let [loading3, setLoading3] = useState(false);
  const [resetPasswordLoadingId, setResetPasswordLoadingId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddStaff, setOpenModalAddStaff] = useState(false);
  const [openModalOut, setOpenModalOut] = useState(false);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const [staffToResetPassword, setStaffToResetPassword] = useState(null);
  const [resetPasswordStatus, setResetPasswordStatus] = useState("confirm");
  const [resetPasswordMessage, setResetPasswordMessage] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: "",
    message: "",
    confirmText: "Confirm",
    color: "blue",
    onConfirm: null,
  });
  const [confirmDialogLoading, setConfirmDialogLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    salary: singleStaff?.salary || 0,
    housingAllowance: singleStaff?.housingAllowance || 0,
    transportAllowance: singleStaff?.transportAllowance || 0,
    educationAllowance: singleStaff?.educationAllowance || 0,
    trainingAllowance: singleStaff?.trainingAllowance || 0,
    payee: singleStaff?.payee || 0,
    pensionContribution: singleStaff?.pensionContribution || 0,
    nhf: singleStaff?.nhf || 0,
    otherDeductions: singleStaff?.otherDeductions || 0,
  });

  const [salaryLoading, setSalaryLoading] = useState(false);

  const formatCurrency = (amount) => {
    if (!amount) return "N/A";
    return `₦${Number(amount).toLocaleString("en-NG", {
      minimumFractionDigits: 0,
    })}`;
  };
  const navigate = useNavigate();

  function onCloseModal() {
    setOpenModal(false);
  }

  function onCloseModalStaff() {
    setOpenModalAddStaff(false);
    setStaffDetails({
      email: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      role: "",
    });
    setError("");
  }

  function onCloseResetPasswordModal() {
    if (resetPasswordLoadingId) return;
    setOpenResetPasswordModal(false);
    setStaffToResetPassword(null);
    setResetPasswordStatus("confirm");
    setResetPasswordMessage("");
  }

  function openConfirmDialog({
    title,
    message,
    confirmText = "Confirm",
    color = "blue",
    onConfirm,
  }) {
    setConfirmDialog({
      show: true,
      title,
      message,
      confirmText,
      color,
      onConfirm,
    });
  }

  function closeConfirmDialog() {
    if (confirmDialogLoading) return;
    setConfirmDialog({
      show: false,
      title: "",
      message: "",
      confirmText: "Confirm",
      color: "blue",
      onConfirm: null,
    });
  }

  async function handleConfirmDialog() {
    if (!confirmDialog.onConfirm) return;

    setConfirmDialogLoading(true);
    try {
      await confirmDialog.onConfirm();
    } finally {
      setConfirmDialogLoading(false);
      setConfirmDialog({
        show: false,
        title: "",
        message: "",
        confirmText: "Confirm",
        color: "blue",
        onConfirm: null,
      });
    }
  }

  const loadStaff = useCallback(async () => {
    setLoading1(true);
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/staff`;
      const { data } = await apiRequest(url, "GET", null, token);
      setStaff(data);
    } catch (error) {
      const unauthorizedErrors = [
        "Access Denied: Invalid or expired token. Please login again",
        "Access Denied: Please log in.",
        "Access Denied: Invalid Token.",
        "Access Denied: Invalid or expired token.",
        "Access Denied: Invalid or Expired Token.",
        "Access Denied: No token provided.",
      ];
      if (unauthorizedErrors.includes(error.message)) {
        setMsg("Session Expired!");
        setOpenModalOut(true);
        localStorage.removeItem("royal-token");
      } else {
        console.log(error);
      }
    }
  }, [baseUrl]);

  const loadRoles = useCallback(async () => {
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/roles`;
      const { data } = await apiRequest(url, "GET", null, token);
      setRoles(data);
    } catch (error) {
      console.log(error);
    }
  }, [baseUrl]);

  useEffect(() => {
    Promise.all([loadStaff(), loadRoles()])
      .then(() => setLoading1(false))
      .catch(() => setLoading1(false));
  }, [loadStaff, loadRoles]);

  const changeStaffStatus = async (a, b) => {
    setLoading2(true);
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/staff/${a}`;
      const { data } = await apiRequest(url, "PUT", { status: b }, token);
      setSingleStaff(data);
      setStaff((prevMessages) =>
        prevMessages.map((singleStaff) =>
          singleStaff.id === data.id ? data : singleStaff,
        ),
      );
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      console.log(error);
    }
  };

  const register = async (a, b) => {
    if (
      !staffDetails.confirmPassword ||
      !staffDetails.password ||
      !staffDetails.email ||
      !staffDetails.firstName ||
      !staffDetails.lastName ||
      !staffDetails.role
    ) {
      setErrorColor("red");
      setError("Please fill all missing fields.");
      return;
    }
    if (!validateEmail(staffDetails.email)) {
      setErrorColor("red");
      setError(
        "Please enter an email address ending with @royalminesproperty.com",
      );
      return;
    }
    if (!validatePassword(staffDetails.password)) {
      setErrorColor("red");
      setError(
        "Password: Minimun of 8 characters, including uppercase, lowercase, numbers, and special characters.",
      );
      return;
    }
    if (staffDetails.confirmPassword !== staffDetails.password) {
      setErrorColor("red");
      setError("Password and Confirm Password do not match.");
      return;
    }
    openConfirmDialog({
      title: "Register Staff",
      message: "Are you sure you want to register a new staff?",
      confirmText: "Yes, register",
      color: "success",
      onConfirm: async () => {
        setLoading3(true);
        try {
          let token = localStorage.getItem("royal-token");
          const url = `${baseUrl}/register`;
          await apiRequest(url, "POST", staffDetails, token);
          setErrorColor("green");
          setError("Successfully registered.");
          setLoading3(false);
          onCloseModalStaff();
          loadStaff();
          setLoading1(false);
        } catch (error) {
          setErrorColor("red");
          setError(error.message);
          setLoading3(false);
          console.log(error);
        }
      },
    });
  };

  const changeStaffRole = async (a, b) => {
    setLoading2(true);
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/staff/${a}`;
      const { data } = await apiRequest(url, "PUT", { role: b }, token);
      setSingleStaff(data);
      setStaff((prevMessages) =>
        prevMessages.map((singleStaff) =>
          singleStaff.id === data.id ? data : singleStaff,
        ),
      );
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      console.log(error.message);
    }
  };

  const openResetPasswordDialog = (staffMember) => {
    setStaffToResetPassword(staffMember);
    setResetPasswordStatus("confirm");
    setResetPasswordMessage("");
    setOpenResetPasswordModal(true);
  };

  const resetStaffPassword = async () => {
    const staffId = staffToResetPassword?.id;
    if (!staffId) return;

    setResetPasswordLoadingId(staffId);
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/password/staff/${staffId}/reset`;
      await apiRequest(url, "PUT", null, token);
      setResetPasswordStatus("success");
      setResetPasswordMessage(
        "The password has been reset to Qwerty@123.",
      );
    } catch (error) {
      setResetPasswordStatus("error");
      setResetPasswordMessage(
        error.message || "Unable to reset staff password.",
      );
      console.log(error.message);
    } finally {
      setResetPasswordLoadingId(null);
    }
  };

  const handleSalaryUpdate = async () => {
    setSalaryLoading(true);

    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/staff/${singleStaff?.id}`;

      const payload = {
        salary: Number(formValues.salary),
        housingAllowance: Number(formValues.housingAllowance),
        transportAllowance: Number(formValues.transportAllowance),
        educationAllowance: Number(formValues.educationAllowance),
        trainingAllowance: Number(formValues.trainingAllowance),

        // --- DEDUCTIONS ---
        payee: Number(formValues.payee),
        pensionContribution: Number(formValues.pensionContribution),
        nhf: Number(formValues.nhf),
        otherDeductions: Number(formValues.otherDeductions),
      };

      const { data } = await apiRequest(url, "PUT", payload, token);

      setSingleStaff(data);

      setStaff((prev) =>
        prev.map((item) => (item.id === data.id ? data : item)),
      );
    } catch (error) {
      console.error("Failed to update salary and allowances:", error);
    } finally {
      setSalaryLoading(false);
    }
  };

  let displayOnModal = (e) => {
    setSingleStaff(e);
    setFormValues(e);
    setOpenModal(true);
  };

  let logOut = () => {
    navigate("/");
  };

  const handleInputChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  const { canWriteStaff } = useAllPermissions();
  const loggedInRoleTitle = loggedInUser?.role?.title
    ?.toLowerCase()
    .replace(/[-_\s]+/g, " ")
    .trim();
  const canResetStaffPassword =
    canWriteStaff &&
    (loggedInRoleTitle === "admin" || loggedInRoleTitle === "super admin");

  const analytics = useMemo(() => {
    const totalStaff = staff.length;
    const activeStaff = staff.filter((member) => member.status === "active").length;
    const inactiveStaff = staff.filter(
      (member) => member.status === "inactive",
    ).length;
    const rolesCount = new Set(
      staff.map((member) => member.role?.title).filter(Boolean),
    ).size;

    return {
      totalStaff,
      activeStaff,
      inactiveStaff,
      rolesCount,
    };
  }, [staff]);

  const AnalyticsCard = ({ title, value, colorClass, icon: Icon }) => (
    <Card className={`shadow-lg p-2 dark:bg-gray-800 border-l-4 ${colorClass}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase">
            {title}
          </p>
          <h2 className="text-2xl font-extrabold text-gray-900 dark:text-white mt-1">
            {value}
          </h2>
        </div>
        <Icon className="w-8 h-8 opacity-60" />
      </div>
    </Card>
  );

  return (
    <>
      <title>Staff</title>
      <meta
        name="description"
        content="Staff Page to the Royalmines Property Office"
      />

      <DashboardLayout active="staff" contentClassName="lg:p-8">
        <h5 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-6 flex items-center">
          <HiUsers className="w-8 h-8 mr-3 text-indigo-600" />
          Staff Management
        </h5>

        <hr className="my-6 border-gray-200 dark:border-gray-700" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <AnalyticsCard
            title="Total Staff"
            value={analytics.totalStaff}
            colorClass="text-indigo-500 border-indigo-500"
            icon={HiUsers}
          />
          <AnalyticsCard
            title="Active Staff"
            value={analytics.activeStaff}
            colorClass="text-green-500 border-green-500"
            icon={HiBadgeCheck}
          />
          <AnalyticsCard
            title="Inactive Staff"
            value={analytics.inactiveStaff}
            colorClass="text-red-500 border-red-500"
            icon={HiUser}
          />
          <AnalyticsCard
            title="Roles"
            value={analytics.rolesCount}
            colorClass="text-cyan-500 border-cyan-500"
            icon={HiOutlineAcademicCap}
          />
        </div>

        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          <Button
            color="success"
            onClick={() => setOpenModalAddStaff(true)}
            disabled={!canWriteStaff}
            className="w-full sm:w-auto"
          >
            <HiPlus className="w-5 h-5 mr-2" />
            New Staff
          </Button>
        </div>

        <Card className="shadow-2xl dark:bg-gray-800 overflow-x-auto min-h-[400px]">
          {loading1 ? (
            <div className="flex justify-center items-center min-h-[320px]">
              <Spinner
                style={{ color: "#0078e7" }}
                aria-label="Loading staff"
                size="xl"
              />
            </div>
          ) : staff.length === 0 ? (
            <div className="flex min-h-[320px] flex-col items-center justify-center text-center">
              <HiUsers className="w-12 h-12 text-gray-300 dark:text-gray-600 mb-3" />
              <h6 className="text-lg font-semibold text-gray-900 dark:text-white">
                No staff found
              </h6>
              <p className="mt-1 max-w-md text-sm text-gray-500 dark:text-gray-400">
                Add a staff member to populate the employee directory.
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto overflow-y-auto max-h-[58vh] scrollbar-always-visible">
              <Table hoverable striped>
                <Table.Head className="sticky top-0 z-10">
                  <Table.HeadCell>Name</Table.HeadCell>
                  <Table.HeadCell>Email</Table.HeadCell>
                  <Table.HeadCell>Phone</Table.HeadCell>
                  <Table.HeadCell>Role</Table.HeadCell>
                  <Table.HeadCell>Status</Table.HeadCell>
                  <Table.HeadCell>
                    <span className="sr-only">Actions</span>
                  </Table.HeadCell>
                </Table.Head>

                <Table.Body className="divide-y">
                  {staff.map((e, i) => (
                    <Table.Row
                      key={e.id || i}
                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                    >
                      <Table.Cell className="whitespace-nowrap font-semibold text-gray-900 dark:text-white">
                        {e.firstName} {e.lastName}
                      </Table.Cell>
                      <Table.Cell className="text-ellipsis">{e?.email}</Table.Cell>
                      <Table.Cell className="text-ellipsis">
                        {e.phone || "N/A"}
                      </Table.Cell>
                      <Table.Cell className="text-ellipsis capitalize">
                        {e.role?.title || "N/A"}
                      </Table.Cell>
                      <Table.Cell>
                        <Badge
                          color={e.status === "active" ? "success" : "warning"}
                        >
                          {e.status || "Unknown"}
                        </Badge>
                      </Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          label={<HiDotsVertical className="w-5 h-5" />}
                          inline
                          arrowIcon={false}
                        >
                          <Dropdown.Item
                            icon={HiEye}
                            onClick={() => displayOnModal(e)}
                            disabled={!canWriteStaff}
                          >
                            View Staff
                          </Dropdown.Item>
                        </Dropdown>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Card>
      </DashboardLayout>

      {/* modal for singleStaff */}
      <Modal
        dismissible
        show={openModal}
        size="5xl" // Increased size for better layout
        onClose={onCloseModal}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header className="border-b border-gray-200 dark:border-gray-700 pb-5">
          <div className="flex items-center gap-4 w-full">
            {/* Avatar Icon */}
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100 dark:bg-indigo-900/40">
              <HiUser className="h-7 w-7 text-indigo-600 dark:text-indigo-300" />
            </div>

            {/* Staff Info */}
            <div className="flex flex-col">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                {singleStaff?.firstName} {singleStaff?.lastName}
              </h3>

              <p className="text-sm text-gray-500 dark:text-gray-400">
                Staff Profile Overview
              </p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 sm:p-6 max-h-[70vh] overflow-y-auto">
          <div className="space-y-6">
            {/* --- DETAILS GRID --- */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Email */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiMail className="h-6 w-6 text-blue-500 mr-3 shrink-0" />
                <div className="truncate">
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Email
                  </p>
                  <h4 className="font-semibold text-gray-900 dark:text-white truncate">
                    {singleStaff?.email?.trim() === "" ||
                    singleStaff?.email === undefined
                      ? "No added email"
                      : singleStaff?.email}
                  </h4>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiPhone className="h-6 w-6 text-yellow-500 mr-3 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Phone
                  </p>
                  <h4 className="font-semibold text-gray-900 dark:text-white">
                    {singleStaff?.phone || "N/A"}
                  </h4>
                </div>
              </div>

              {/* Date Created */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiCalendar className="h-6 w-6 text-purple-500 mr-3 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Date Created
                  </p>
                  <h4 className="font-semibold text-gray-900 dark:text-white">
                    {formatDate(singleStaff?.createdAt)}
                  </h4>
                </div>
              </div>

              {/* Role */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiOutlineAcademicCap className="h-6 w-6 text-cyan-500 mr-3 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Role
                  </p>
                  <h4 className="font-semibold text-gray-900 dark:text-white capitalize">
                    {singleStaff?.role?.title || "N/A"}
                  </h4>
                </div>
              </div>

              {/* Status */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiBadgeCheck className="h-6 w-6 text-red-500 mr-3 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Status
                  </p>
                  {/* Custom Status Badge (Requires the StatusBadge helper component if defined) */}
                  <span
                    className={`inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full capitalize ${
                      singleStaff?.status === "active"
                        ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
                        : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300"
                    }`}
                  >
                    <span
                      className={`w-2 h-2 me-1.5 rounded-full ${
                        singleStaff?.status === "active"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                    ></span>
                    {singleStaff?.status}
                  </span>
                </div>
              </div>

              {/* Current Salary (Read-Only) */}
              <div className="flex items-center p-3 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-sm">
                <HiCreditCard className="h-6 w-6 text-teal-500 mr-3 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Current Salary
                  </p>
                  <h4 className="font-semibold text-gray-900 dark:text-white">
                    {formatCurrency(singleStaff?.salary)}
                  </h4>
                </div>
              </div>
            </div>

            {/* --- EARNINGS SECTION --- */}
            <div className="mt-6 pt-4 border-t dark:border-gray-700">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3">
                Earnings
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* BASIC SALARY */}
                <div>
                  <Label htmlFor="housingAllowance" value="Basic Salary" />
                  <TextInput
                    type="number"
                    step="0.01"
                    placeholder="Enter new base salary (e.g., 500000)"
                    value={formValues.salary}
                    onChange={(e) =>
                      handleInputChange("salary", e.target.value)
                    }
                    className="flex-grow"
                    min={0}
                    icon={HiCreditCard}
                    disabled={!canWriteStaff}
                  />
                </div>

                {/* Housing Allowance */}
                <div>
                  <Label htmlFor="housingAllowance" value="Housing Allowance" />
                  <TextInput
                    id="housingAllowance"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.housingAllowance}
                    onChange={(e) =>
                      handleInputChange("housingAllowance", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>

                {/* Transport Allowance */}
                <div>
                  <Label
                    htmlFor="transportAllowance"
                    value="Transport Allowance"
                  />
                  <TextInput
                    id="transportAllowance"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.transportAllowance}
                    onChange={(e) =>
                      handleInputChange("transportAllowance", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>

                {/* Education Allowance */}
                <div>
                  <Label
                    htmlFor="educationAllowance"
                    value="Education Allowance"
                  />
                  <TextInput
                    id="educationAllowance"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.educationAllowance}
                    onChange={(e) =>
                      handleInputChange("educationAllowance", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>

                {/* Training Allowance */}
                <div>
                  <Label
                    htmlFor="trainingAllowance"
                    value="Training Allowance"
                  />
                  <TextInput
                    id="trainingAllowance"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.trainingAllowance}
                    onChange={(e) =>
                      handleInputChange("trainingAllowance", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>
              </div>
            </div>

            {/* --- DEDUCTIONS SECTION --- */}
            <div className="mt-6 pt-4 border-t dark:border-gray-700">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3">
                Deductions
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* PAYE */}
                <div>
                  <Label htmlFor="paye" value="PAYE" />
                  <TextInput
                    id="paye"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.payee}
                    disabled={!canWriteStaff}
                    onChange={(e) => handleInputChange("payee", e.target.value)}
                  />
                </div>

                {/* Pension Contribution */}
                <div>
                  <Label
                    htmlFor="pensionContribution"
                    value="Pension Contribution"
                  />
                  <TextInput
                    id="pensionContribution"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.pensionContribution}
                    onChange={(e) =>
                      handleInputChange("pensionContribution", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>

                {/* NHF */}
                <div>
                  <Label htmlFor="nhf" value="NHF" />
                  <TextInput
                    id="nhf"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.nhf}
                    disabled={!canWriteStaff}
                    onChange={(e) => handleInputChange("nhf", e.target.value)}
                  />
                </div>

                {/* Other Deductions */}
                <div>
                  <Label htmlFor="otherDeductions" value="Other Deductions" />
                  <TextInput
                    id="otherDeductions"
                    type="number"
                    step="0.01"
                    icon={HiCreditCard}
                    placeholder="Enter amount"
                    value={formValues.otherDeductions}
                    onChange={(e) =>
                      handleInputChange("otherDeductions", e.target.value)
                    }
                    disabled={!canWriteStaff}
                  />
                </div>
              </div>
            </div>

            {/* --- ADMINISTRATIVE ACTIONS --- */}
            <div className="w-full flex justify-center gap-4 mt-6 pt-4 border-t dark:border-gray-700">
              {/* Change Role Dropdown */}
              <Dropdown
                label="Change Role"
                dismissOnClick={true}
                color="blue"
                className="capitalize"
                disabled={!canWriteStaff || resetPasswordLoadingId}
              >
                {roles?.map((role) => (
                  <Dropdown.Item
                    key={role.id}
                    className="capitalize"
                    onClick={() =>
                      openConfirmDialog({
                        title: "Change Staff Role",
                        message: `Are you sure you want to change ${singleStaff?.firstName} ${singleStaff?.lastName}'s role to ${role.title}?`,
                        confirmText: "Yes, change role",
                        color: "blue",
                        onConfirm: () =>
                          changeStaffRole(singleStaff.id, role.id),
                      })
                    }
                  >
                    {role.title}
                  </Dropdown.Item>
                ))}
              </Dropdown>

              {canResetStaffPassword && (
                <Button
                  color="warning"
                  onClick={() => openResetPasswordDialog(singleStaff)}
                  disabled={resetPasswordLoadingId === singleStaff.id}
                >
                  {resetPasswordLoadingId === singleStaff.id ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Resetting...
                    </>
                  ) : (
                    <>
                      <HiKey className="w-5 h-5 mr-2" />
                      Reset Password
                    </>
                  )}
                </Button>
              )}

              {/* Deactivate/Activate Button */}
              {singleStaff?.status === "active" ? (
                <Button
                  color="failure"
                  onClick={() =>
                    openConfirmDialog({
                      title: "Deactivate Staff",
                      message: `Are you sure you want to deactivate ${singleStaff?.firstName} ${singleStaff?.lastName}?`,
                      confirmText: "Yes, deactivate",
                      color: "failure",
                      onConfirm: () =>
                        changeStaffStatus(singleStaff.id, "inactive"),
                    })
                  }
                  disabled={!canWriteStaff || loading2}
                >
                  {loading2 ? (
                    <Spinner size="sm" className="mr-2" />
                  ) : (
                    <HiUser className="w-5 h-5 mr-2" />
                  )}
                  Deactivate
                </Button>
              ) : (
                <Button
                  color="success"
                  onClick={() =>
                    openConfirmDialog({
                      title: "Activate Staff",
                      message: `Are you sure you want to activate ${singleStaff?.firstName} ${singleStaff?.lastName}?`,
                      confirmText: "Yes, activate",
                      color: "success",
                      onConfirm: () =>
                        changeStaffStatus(singleStaff.id, "active"),
                    })
                  }
                  disabled={loading2}
                >
                  {loading2 ? (
                    <Spinner size="sm" className="mr-2" />
                  ) : (
                    <HiUser className="w-5 h-5 mr-2" />
                  )}
                  Activate
                </Button>
              )}

              {/* SAVE PROFILE CHANGES */}
              <Button
                color="indigo"
                onClick={handleSalaryUpdate}
                disabled={!canWriteStaff || salaryLoading}
              >
                {salaryLoading ? (
                  <>
                    <Spinner size="sm" className="mr-2" />
                    Saving…
                  </>
                ) : (
                  <>
                    <HiCheck className="w-5 h-5 mr-1" />
                    Save Changes
                  </>
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* --- END OF REDESIGNED MODAL --- */}

      <ConfirmDialog
        show={confirmDialog.show}
        title={confirmDialog.title}
        message={confirmDialog.message}
        confirmText={confirmDialog.confirmText}
        color={confirmDialog.color}
        loading={confirmDialogLoading}
        onConfirm={handleConfirmDialog}
        onClose={closeConfirmDialog}
      />

      {/* modal for reset password */}
      <Modal
        show={openResetPasswordModal}
        size="md"
        onClose={onCloseResetPasswordModal}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            {resetPasswordStatus === "success" ? (
              <HiCheck className="mx-auto mb-4 h-14 w-14 text-green-500" />
            ) : (
              <HiOutlineExclamationCircle
                className={`mx-auto mb-4 h-14 w-14 ${
                  resetPasswordStatus === "error"
                    ? "text-red-500"
                    : "text-yellow-500"
                }`}
              />
            )}

            {resetPasswordStatus === "confirm" ? (
              <>
                <h3 className="mb-3 text-lg font-normal text-gray-500 dark:text-gray-400">
                  Reset password for {staffToResetPassword?.firstName}{" "}
                  {staffToResetPassword?.lastName}?
                </h3>
                <p className="mb-5 text-sm text-gray-500 dark:text-gray-400">
                  This will reset the staff password to Qwerty@123.
                </p>
                <div className="flex justify-center gap-4">
                  <Button
                    color="warning"
                    onClick={resetStaffPassword}
                    disabled={!!resetPasswordLoadingId}
                  >
                    {resetPasswordLoadingId ? (
                      <>
                        <Spinner size="sm" className="mr-2" />
                        Resetting...
                      </>
                    ) : (
                      "Yes, reset password"
                    )}
                  </Button>
                  <Button
                    color="gray"
                    onClick={onCloseResetPasswordModal}
                    disabled={!!resetPasswordLoadingId}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <>
                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                  {resetPasswordMessage}
                </h3>
                <div className="flex justify-center">
                  <Button color="gray" onClick={onCloseResetPasswordModal}>
                    OK
                  </Button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* modal for logout */}
      <Modal
        show={openModalOut}
        size="md"
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {msg}
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={() => logOut()}>
                {"OK"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* modal for add staff */}
      <Modal
        show={openModalAddStaff}
        size="md"
        onClose={onCloseModalStaff}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white text-center">
              Register Staff
            </h3>
            <div className="flex justify-center">
              <small
                style={{
                  color: errorColor,
                  textAlign: "center",
                }}
              >
                {error}
              </small>
            </div>
            <div>
              <TextInput
                id="firstName"
                placeholder="First Name"
                value={staffDetails.firstName}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    firstName: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="lastName"
                placeholder="Last Name"
                value={staffDetails.lastName}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    lastName: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="email"
                placeholder="Email Address"
                value={staffDetails.email}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    email: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <Select
                id="Role"
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    role: event.target.value,
                  })
                }
                required
                style={{ textTransform: "capitalize" }}
              >
                <option value="">Select a Role</option>;
                {roles.map((role) => {
                  return <option value={role.id}>{role.title}</option>;
                })}
              </Select>
            </div>
            <div>
              <TextInput
                id="password"
                type="password"
                placeholder="Password"
                value={staffDetails.password}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    password: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="password1"
                type="password"
                placeholder="Confirm Password"
                value={staffDetails.confirmPassword}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    confirmPassword: event.target.value,
                  })
                }
                required
              />
            </div>
            <div className="w-full flex justify-center">
              <Button disabled={loading3} onClick={() => register()}>
                {loading3 ? "Loading..." : "Register"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Users;

function formatDate(dateString) {
  const dateObj = new Date(dateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[dateObj.getMonth()];

  const desiredFormat = `${dateObj.getFullYear()}-${month}-${dateObj.getDate()}`;

  return desiredFormat;
}

function validatePassword(password) {
  const re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$/;
  return re.test(password);
}

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@royalminesproperty.com/;
  return re.test(String(email).toLowerCase());
}
